import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from "react-modal";
import { useAuthContext } from '../hooks/useAuthContext';
//importing modals and components
import CreatePO from '../components/modals/PO modals/CreatePO';
import EditPO from '../components/modals/PO modals/EditPO';
import MoveToInv from '../components/modals/PO modals/MoveToInv';
import PODetails from '../components/modals/PO modals/PODetails';

const PurchaseOrders = () => {
    const [watches, setWatches] = useState(); //watches variable will hold all purchase orders returned from API call to DB
    const [selectedWatchId, setSelectedWatchId] = useState();
    const [selectedWatch, setSelectedWatch] = useState();
    const [purStatus, setPurStatus] = useState('Paid');
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [year, setYear] = useState(new Date().getFullYear());
    const [openCreateModal, setOpenCreateModal] = useState(false);
    const [openMoveToInvModal, setOpenMoveToInvModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openDetailsModal, setOpenDetailsModal] = useState(false);
    const {user} = useAuthContext(); //grabbing the user object that is returned from the useAuthContext hook

    //get screensize
    const getScreenSize = () => {
        const width = window.innerWidth;
        if (width < 500) return 'xsmall';
        if (width >= 500 && width < 800) return 'small';
        if (width >= 800 && width < 1440) return 'medium';
        return 'large';
    };
    const [screenSize, setScreenSize] = useState(getScreenSize());



    useEffect(() => {
        const getPurOrders = async () => {
            try {
                const response = await axios.get(
                    // eslint-disable-next-line
                    process.env.REACT_APP_SERVER_URL + '/api/purchaseOrders' + `?purStatus=${purStatus}&month=${month}&year=${year}`,
                    {headers: {'Authorization': `Bearer ${user.token}`}}
                ); //get all purchase orders
                setWatches(response.data);
                // console.log('Watches: ' + JSON.stringify(watches));
            } catch (error) {
                console.error('Failed to get all purchase orders: ' + error.message);
            }
        }

        if (user) {
            getPurOrders();
        }

        const handleResize = () => {
            setScreenSize(getScreenSize());
          };
      
        window.addEventListener('resize', handleResize);
      
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [user, purStatus, month, year])



    const newPO = () => {
        setOpenCreateModal(true);
    }
    const closeCreateModal = () => {
        setOpenCreateModal(false);
    }

    const moveToInv = (id) => {
        setOpenMoveToInvModal(true);
        setSelectedWatchId(id);
    }
    const closeMoveToInvModal = () => {
        setOpenMoveToInvModal(false);
    }

    const edit = (watch) => {
        setOpenEditModal(true);
        setSelectedWatch(watch)
    }
    const closeEditModal = () => {
        setOpenEditModal(false);
    }

    const detailsModal = (watch) => {
        setOpenDetailsModal(true);
        setSelectedWatch(watch);
    }
    const closeDetailsModal = () => {
        setOpenDetailsModal(false);
    }

    //delete selected PO
    const deletePO = async (id) => {
        try {
            const response = await axios.delete(process.env.REACT_APP_SERVER_URL +'/api/purchaseOrders/deletePO/' + id,
                {headers: {'Authorization': `Bearer ${user.token}`}}
            );
            console.log('Deleted purchase order: ' + response.data);
            setWatches(watches.filter((watch) => watch._id !== id));
        } catch (e) {
            console.log(e.response.data.error);
        }  
    }



    return (
        <div className="pur-order-details">

            {/* Create Purchase Order Modal */}
            <Modal
                isOpen={openCreateModal}
                onRequestClose={closeCreateModal}
                contentLabel="Create Purchase Order"
            >
                <div className="modal-header">
                    <h2>Purchase</h2>
                    <button className="btn btn-light" onClick={closeCreateModal}>Close</button>
                </div>
                <CreatePO />
            </Modal>

            {/* Move To Inv Modal */}
            <Modal
                isOpen={openMoveToInvModal}
                onRequestClose={closeMoveToInvModal}
                contentLabel="Move To Inventory"
            >
                <div className="modal-header">
                    <h2>Move To Inventory</h2>
                    <button className="btn btn-light" onClick={closeMoveToInvModal}>Close</button>
                </div>
                <MoveToInv watchId={selectedWatchId} />
            </Modal>

            {/* Edit Purchase Order Modal */}
            <Modal
                isOpen={openEditModal}
                onRequestClose={closeEditModal}
                contentLabel="Edit Purchase Order"
            >
                <div className="modal-header">
                    <h2>Purchase</h2>
                    <button className="btn btn-light" onClick={closeEditModal}>Close</button>
                </div>
                <EditPO watch={selectedWatch}/>
            </Modal>

            {/* PO Details */}
            <Modal
                isOpen={openDetailsModal}
                onRequestClose={closeDetailsModal}
                contentLabel="Purchase Details"
            >
                <div className="modal-header">
                    <h2>Purchase Details</h2>
                    <button className="btn btn-light" onClick={closeDetailsModal}>Close</button>
                </div>
                <PODetails watch={selectedWatch}/>
            </Modal>

            <div className="top-banner">
                <h2>Purchases - {month}/{year-2000}</h2>
                <button className="btn btn-light" onClick={newPO}><i className="fa-regular fa-plus"></i>New Purchase Order</button>
            </div>

            <div className="purchase-filters">
                <select
                    className="form-select"
                    onChange={(event) => setMonth(event.target.value)}
                    value={month} 
                > 
                    <option value='1'>Jan</option>
                    <option value="2">Feb</option>
                    <option value="3">Mar</option>
                    <option value="4">Apr</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">Aug</option>
                    <option value="9">Sep</option>
                    <option value="10">Oct</option>
                    <option value="11">Nov</option>
                    <option value="12">Dec</option>
                </select>
                <select
                    className="form-select"
                    onChange={(event) => setYear(event.target.value)}
                    value={year} 
                > 
                    <option value='2024'>2024</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2028">2027</option>
                    <option value="2028">2028</option>
                </select>
                <select
                    className="form-select"
                    onChange={(event) => setPurStatus(event.target.value)}
                    value={purStatus} 
                > 
                    <option value='Paid'>Paid</option>
                    <option value="Received">Received</option>
                </select>
            </div>

            <table className="pur-order-table table">
                <thead>
                    <tr>
                        <th>Details</th>
                        {screenSize !== 'xsmall' && screenSize !== 'small' && <th>Purchase Date</th>}
                        {screenSize !== 'xsmall' && screenSize !== 'small' && <th>Brand</th>}
                        <th>Model</th>
                        {screenSize === 'large' && <th>Year</th>}
                        {screenSize === 'large' && <th>Condition</th>}
                        {screenSize === 'large' && <th>Box</th>}
                        {screenSize === 'large' && <th>Papers</th>}
                        {screenSize === 'large' && <th>Purchase Status</th>}
                        {screenSize !== 'xsmall' && <th>Purchase Price</th>}
                        <th>Move To Inv.</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {watches && watches.map((watch) => (                        
                        <tr key={watch._id}>
                            <td><button className='btn' onClick={() => detailsModal(watch)}><i className="fa-regular fa-eye"></i></button></td>
                            {screenSize !== 'xsmall' && screenSize !== 'small' && <td>{watch.purOrder.purDate.slice(0,10)}</td>}
                            {screenSize !== 'xsmall' && screenSize !== 'small' && <td>{watch.brand}</td>}
                            <td>{watch.model}</td>
                            {screenSize === 'large' && <td>{watch.year}</td>}
                            {screenSize === 'large' && <td>{watch.condition}</td>}
                            {/* circle-xmark or circle-check based on boolean value for box/papers */}
                            {screenSize === 'large' && <td><i className={watch.box ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle-xmark'}></i></td>}
                            {screenSize === 'large' && <td><i className={watch.papers ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle-xmark'}></i></td>}
                            {screenSize === 'large' && <td>{watch.purOrder.purStatus}</td>}
                            {screenSize !== 'xsmall' && <td>${watch.purOrder.purPrice}</td>}
                            <td>{watch.status === "Purchased" ? <button className='btn' onClick={() => moveToInv(watch._id)}><i className="fa-solid fa-warehouse"></i></button> : ''}</td>
                            <td><button className='btn' onClick={() => edit(watch)}><i className="fa-solid fa-pen"></i></button></td>
                            <td><button className='btn' onClick={user ? () => deletePO(watch._id) : null}><i className="fa-regular fa-trash-can"></i></button></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default PurchaseOrders;